/**
 * Dashboard page tour — auto-triggered on first visit to /dashboard.
 *
 * data-tour attributes expected in Dashboard.jsx:
 *   dashboard-filter-bar    The date / range filter bar at the top
 *   dashboard-stat-cards    The primary KPI stat cards grid
 *   dashboard-chart         The freight volume chart
 *   dashboard-recent-quotes The recent quotes table
 *   dashboard-pending-tasks The pending tasks / notifications panel
 */

export const dashboardTour = {
  id: "dashboard",
  label: "Dashboard Overview",
  steps: [
    {
      target: "dashboard-filter-bar",
      title: "Filter Your View",
      description:
        "Use these controls to change the time period you're looking at — daily, weekly, monthly, or a custom date range. The numbers on this page will update automatically.",
      hint: "Try switching to 'Monthly' to compare performance across months.",
      placement: "bottom",
    },
    {
      target: "dashboard-stat-cards",
      title: "Key Numbers at a Glance",
      description:
        "These cards show your most important metrics: total quotes, revenue, active shipments, and more. Click any card to drill deeper into that area.",
      placement: "bottom",
    },
    {
      target: "dashboard-chart",
      title: "Freight Volume Over Time",
      description:
        "This chart shows how your freight volume has changed over the selected period. A rising line means more activity — great for spotting busy seasons or slow periods.",
      placement: "top",
    },
    {
      target: "dashboard-recent-quotes",
      title: "Recent Finalized Quotes",
      description:
        "The table below lists the quotes your team has recently closed. Click any row to open the full quote and see all its details.",
      placement: "top",
    },
  ],
};
